import React from 'react'

import { Alert as MaterialAlert, AlertTitle as MaterialAlertTitle } from '@material-ui/lab'
import { withStyles } from '@material-ui/core/styles'

const Alert = ({ classes, title, color, text, variant, noMargin, ...rest }) => {
    return (
        <div className={noMargin ? '' : classes.marginized} {...rest}>
            <MaterialAlert severity={color} variant={variant}>
                {title && ( <MaterialAlertTitle>{title}</MaterialAlertTitle>)}
                {typeof text === 'function' ? text() : text}
            </MaterialAlert>
        </div>
    )
}

const styles = theme => ({
    marginized: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2)
    }
})


export default withStyles(styles)(Alert);